module.exports = __webpack_public_path__ + "img/noPosts.49e46071.svg";